import { jsx as _jsx } from "react/jsx-runtime";
import { Container, MapTo } from "@adobe/aem-react-editable-components";
import { TextV2RichText } from "@jti/aem-core-components-react-base/dist/authoring/text/v2/TextV2";
import { ArticleRestrictedContent } from "@jti/loyalty";
import { withAemAuthoring } from "../../app-related/withAemAuthoring";
export const articleRestrictedContentEditConfig = {
    emptyLabel: "Article Restricted Content",
    isEmpty: (props) => {
        const baseCondition = !props.previewContent || !props.primaryBtnUrl || !props.secondaryBtnUrl;
        if (props.disableTiers)
            return baseCondition;
        return baseCondition || !props.primaryBtnUrlRestricted;
    },
    getProps: (props) => props,
};
const ArticleRestrictedContentWrapper = ({ primaryBtnUrl, secondaryBtnUrl, previewContent, primaryBtnUrlRestricted, isInEditor, article, disableTiers, ...restArgs }) => {
    return (_jsx(ArticleRestrictedContent, { primaryBtnUrl,
        secondaryBtnUrl,
        previewContent,
        primaryBtnUrlRestricted,
        isInEditor,
        article,
        disableTiers, richTextComponent: TextV2RichText, children: _jsx(Container, { ...restArgs, isInEditor: isInEditor, className: "aem-container" }) }));
};
export default MapTo("loyalty/components/article-restricted-content")(withAemAuthoring(ArticleRestrictedContentWrapper, articleRestrictedContentEditConfig));
